import { useState, useEffect } from 'react'
import { me, listConnections, createConnection, deleteConnection } from '../lib/api'
import CrmCard from '../components/CrmCard'
import { useLang } from '../lib/useLang'

const PROVIDERS = [
  { id: 'salesforce', name: 'Salesforce', logo: '/icons/salesforce.svg' },
  { id: 'hubspot', name: 'HubSpot', logo: '/icons/hubspot.svg' },
]

export default function IntegrationsPage() {
  const { t } = useLang()
  const [userId, setUserId] = useState(null)
  const [connections, setConnections] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    me().then(d => setUserId(d.email)).catch(() => setUserId(null))
  }, [])

  const fetchConnections = async () => {
    if (!userId) return
    setLoading(true)
    try {
      const data = await listConnections(userId)
      setConnections(data)
    } catch (e) {
      console.error('Failed to load connections', e)
    }
    setLoading(false)
  }

  useEffect(() => { if (userId) fetchConnections() }, [userId])

  const handleConnect = async (provider) => {
    const callbackUrl = `${window.location.origin}/settings/integrations/callback`
    const { auth_url } = await createConnection(userId, provider, callbackUrl)
    window.location.href = auth_url
  }

  const handleDisconnect = async (connectionId) => {
    await deleteConnection(connectionId, userId)
    fetchConnections()
  }

  if (loading) return <div className="flex justify-center p-8"><span className="loading loading-spinner" /></div>

  return (
    <div className="max-w-3xl mx-auto p-6 min-h-[calc(100vh-76px)]" style={{
      background: `radial-gradient(ellipse 100% 60% at 50% 20%, rgba(255, 90, 31, 0.12) 0%, transparent 50%),
                   radial-gradient(ellipse 80% 50% at 50% 50%, rgba(196, 61, 16, 0.08) 0%, transparent 60%),
                   #F5F1E8`,
    }}>
      <h1 className="text-2xl font-bold mb-6">{t('integrationsPage.title')}</h1>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {PROVIDERS.map(p => {
          const conn = connections.find(c => c.provider === p.id)
          return (
            <CrmCard
              key={p.id}
              provider={p}
              connection={conn}
              onConnect={() => handleConnect(p.id)}
              onDisconnect={() => handleDisconnect(conn?.id)}
            />
          )
        })}
      </div>
    </div>
  )
}
